import { SiteHeader } from '../features/landing/SiteHeader.tsx';
import { AppFeatureSection } from '../features/landing/AppFeatureSection.tsx';
import { ClosingCTA } from '../features/landing/ClosingCTA.tsx';
import { SiteFooter } from '../features/landing/SiteFooter.tsx';
import { products } from '../features/landing/products.ts';
import { useMarketingChrome } from '../features/landing/useMarketingChrome.ts';

/**
 * The Applications page — every Wapplify Office tool laid out in full, each with
 * its detailed feature grid. Shares the landing's Material 3 chrome (light /
 * RTL / Dhivehi). Reached from the header's "applications" nav link.
 */
export function Applications(): JSX.Element {
  useMarketingChrome();

  return (
    <div id="top" className="landing-dv overflow-x-clip bg-background text-foreground">
      <SiteHeader />

      {/* masthead */}
      <section className="relative overflow-hidden bg-background">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 h-[32rem]"
          style={{
            backgroundImage:
              'radial-gradient(60rem 24rem at 50% -14%, hsl(var(--primary) / 0.08), transparent 64%)',
            maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)',
          }}
        />
        <div className="relative folio-wide pb-12 pt-14 text-center sm:pt-20">
          <span className="chip-dv">ވެޕްލިފައި އޮފީސް · ސުއިޓް</span>
          <h1 className="head-dv mx-auto mt-4 max-w-2xl text-[2.4rem] leading-[1.35] text-ink sm:text-[3.2rem] sm:leading-[1.3]">
            <span className="text-[hsl(var(--primary))]">އެޕްލިކޭޝަންތައް</span>
          </h1>
          <p className="mx-auto mt-5 max-w-xl leading-loose text-muted-foreground">
            ވެޕްލިފައި އޮފީހުގައި ހިމެނޭ ކޮންމެ ޓޫލެއްގެ ފުރިހަމަ ފީޗާތައް — ސޮއިކުރުމުން ފެށިގެން
            ބައްދަލުވުމާއި ބޯހިމެނުމާ ހަމައަށް.
          </p>

          {/* quick jump to each app */}
          <nav className="mt-9 flex flex-wrap justify-center gap-1">
            {products.map((p) => (
              <a key={p.key} href={`#${p.key}`} className="btn-ghost">
                {p.name}
              </a>
            ))}
          </nav>
        </div>
      </section>

      {products.map((p, i) => (
        <AppFeatureSection key={p.key} product={p} index={i} />
      ))}

      <ClosingCTA />
      <SiteFooter />
    </div>
  );
}
